export const sidePanelData = {
  columns: ['p', 't', 'd'],
  data: [{
    p: 'lgd',
    t: '0-1',
    d: 'Indica si el usuario está logeado'
  },
  {
    p: 'req_t',
    t: '1-4',
    d: 'Indica el tipo de petición, 1: Home, 2: Página de libro, 3: Página de autor, 4: ULTE'
  },
  {
    p: 'adt_cnt',
    t: '0-1',
    d: 'Indica si al usuario se le deben mostrar obras de contenido adulto'
  },
  {
    p: 'cu_wrk',
    t: 'id numérica (-1 otherwise).',
    d: 'Id del libro que se esta visitando'
  },
  {
    p: 'cu_aut',
    t: 'id numérica (-1 otherwise).',
    d: 'Id del autor que se esta visitando'
  },
  {
    p: 'pr_wrk',
    t: "array de id's numéricas.",
    d: 'Lista de libros previamente visitados'
  },
  {
    p: 'pr_aut',
    t: "array de id's numéricas.",
    d: 'Lista de autores previamente visitados'
  },
  {
    p: 'cat',
    t: "array de id's numéricas.",
    d: 'Lista de categorías afines al usuario'
  },
  {
    p: 'stk',
    t: "array de id's numéricas.",
    d: 'Lista de stickers afines al usuario'
  },
  {
    p: 'wrk',
    t: "array de id's numéricas.",
    d: 'Lista de libros afines al usuario'
  },
  {
    p: 'aut',
    t: "array de id's numéricas.",
    d: 'Lista de autores afines al usuario'
  },
  {
    p: 'prd',
    t: "array de id's numéricas.",
    d: 'Lista de periodos afines al usuario'
  },
  {
    p: 'wr_ep',
    t: "array de id's numéricas.",
    d: 'Lista de épocas de escritura afines al usuario'
  },
  {
    p: 'loc',
    t: "array de id's numéricas.",
    d: 'Lista de lugares afines al usuario'
  },
  {
    p: 'sga',
    t: "array de id's numéricas.",
    d: 'Lista de sagas afines al usuario'
  },
  {
    p: 'batch_books',
    t: "array de id's numéricas.",
    d: "Lista de las id's de los libros de los cuales se requiere la afinidad"
  }
  ]
};



// WEBPACK FOOTER //
// ./src/components/Layout/sidePanelData.js